import React, { useState } from 'react';
import { Popover, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { StyledSearchWrapper, SearchToolEle } from './styled';

const SearchTool = ({ searchText, changeFuncDataAction, currentKey, currentSearchText = '' }) => {
  const [visible, setVisible] = useState(false);
  const [draft, setDraft] = useState(currentSearchText);
  const handleSearch = (value: string) => {
    changeFuncDataAction({
      searchText: { ...searchText, [currentKey]: value },
      columnKey: currentKey,
    });
    setVisible(false);
  };
  return (
    <Popover
      onOpenChange={(open) => {
        setVisible(open);
        if (open) setDraft(currentSearchText);
      }}
      content={
        <StyledSearchWrapper>
          <Input.Search
            value={draft}
            allowClear
            onSearch={handleSearch}
            onChange={(event) => {
              setDraft(event.target.value);
            }}
            autoFocus
            size="small"
            enterButton="Search"
          />
        </StyledSearchWrapper>
      }
      placement="bottom"
      trigger="click"
      open={visible}
    >
      <SearchToolEle $show={visible || currentSearchText !== ''} icon={<SearchOutlined />} />
    </Popover>
  );
};
export default SearchTool;
